<template>
  <!-- 基本信息 -->
  <div class="module-info">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="demo-ruleForm"
    >
      <el-form-item
        :label="$t('pages.equipment.text5')"
        prop="belongCategoryId"
      >
        <el-select
          v-model="ruleForm.belongCategoryId"
          :placeholder="$t('pages.equipment.text27')"
          :disabled="moduleState != 0"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('pages.equipment.text6')" prop="bikeTypeName">
        <el-input
          v-model="ruleForm.bikeTypeName"
          :disabled="moduleState == 2"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.equipment.text23')" prop="bikeTypeCode">
        <el-input
          v-model="ruleForm.bikeTypeCode"
          :disabled="moduleState == 2"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.equipment.text24')">
        <DiluUploadImage
          :limit="1"
          accept=".png"
          :fileList="fileList"
          @remove="removeimg"
          @success="success"
          :uploaDisabled="moduleState == 2"
        />
      </el-form-item>

      <el-form-item :label="$t('pages.equipment.text29')" prop="bikeCtrlType">
        <el-select
          v-model="ruleForm.bikeCtrlType"
          :placeholder="$t('pages.equipment.text30')"
          :disabled="moduleState == 2"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="(item, index) in crtlType"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('pages.equipment.text31')"
        prop="lowPowerPercent"
      >
        <el-input-number
          v-model="ruleForm.lowPowerPercent"
          :step="1"
          step-strictly
          :disabled="moduleState == 2"
          :min="0"
          :max="100"
        ></el-input-number
        ><span class="company">%</span>
      </el-form-item>
      <el-form-item
        :label="$t('menu.protocol')"
        prop="protocol"
      >
        <el-select
          v-model="ruleForm.protocol"
          :placeholder="$t('button.pleaseSelect')"
          :disabled="moduleState == 2"
          clearable
        >
          <el-option
            v-for="(item, index) in protocolList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import DiluUploadImage from "../../../../components/pubilc/dilu-uploadimages.vue";
export default {
  data() {
    return {
      fileList: [],
      protocolList: [],
      ruleForm: {
        belongCategoryId: "", //车辆类别id
        bikeTypeName: "", //车辆型号名称
        bikeTypeCode: "", //车辆型号代码
        bikeTypeImageName: "", //车辆型号图片名称
        bikeTypeImagePath: "", //车辆型号图片链接
        bikeCtrlType: "", //车辆控制方式，1 4g+蓝牙 2 纯蓝牙 3 纯4g
        lowPowerPercent: 1, //低电阈值
        protocol: null, //故障协议
      },
      crtlType: [
        {
          value: 1,
          label: this.$t("pages.equipment.text32"),
        },
        {
          value: 2,
          label: this.$t("pages.equipment.text33"),
        },
        {
          value: 3,
          label: this.$t("pages.equipment.text34"),
        },
      ],
      rules: {
        bikeTypeName: [
          {
            required: true,
            message: this.$t("pages.equipment.text35"),
            trigger: "blur",
          },
          {
            min: 1,
            max: 15,
            message: this.$t("pages.equipment.text35"),
            trigger: "blur",
          },
        ],
        bikeTypeCode: [
          { required: true, message: "请输入型号代码", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        belongCategoryId: [
          {
            required: true,
            message: this.$t("pages.equipment.text27"),
            trigger: "blur",
          },
        ],
        bikeCtrlType: [
          {
            required: true,
            message: this.$t("pages.equipment.text36"),
            trigger: "blur",
          },
        ],
        lowPowerPercent: [
          {
            required: true,
            message: this.$t("pages.equipment.text37"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    ruleForm: {
      handler: function () {
        // this.$refs["ruleForm"].resetFields(); //清除验证提示
        this.$emit("mergeParams", this.ruleForm);
      },
      deep: true,
    },
    activeName: {
      immediate: true,
      handler: function (val) {
        if (val != "basic") {
          this.fileList = [];
        }
        // console.log(this.params);
        this.ruleForm = {
          belongCategoryId: this.params.belongCategoryId, //车辆类别id
          bikeTypeName: this.params.bikeTypeName, //车辆型号名称
          bikeTypeCode: this.params.bikeTypeCode, //车辆型号代码
          bikeTypeImageName: this.params.bikeTypeImageName, //车辆型号图片名称
          bikeTypeImagePath: this.params.bikeTypeImagePath, //车辆型号图片链接
          bikeCtrlType: this.params.bikeCtrlType, //车辆控制方式 1 4g+蓝牙 2 纯蓝牙 3 纯4g
          lowPowerPercent: this.params.lowPowerPercent, //低电阈值
          protocol: this.params.protocol, //故障协议
        };
        if (this.params.bikeTypeImagePath) {
          if (this.fileList.length > 0) {
            return;
          }
          this.fileList = [
            {
              name: this.params.bikeTypeImageName,
              url: this.params.bikeTypeImagePath,
            },
          ];
        } else {
          this.fileList = [];
        }
        this.getProtocol();
      },
      deep: true,
    },
  },
  props: ["activeName", "options", "params", "moduleState"],
  components: {
    DiluUploadImage,
  },
  methods: {
    getProtocol() {
      this.request.getProtocol().then((res) => {
        this.protocolList=res.data;
      }).catch(() => {});
    },
    //删除图片
    removeimg(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.bikeTypeImageName = null;
      this.ruleForm.bikeTypeImagePath = null;
    },
    //上传成功
    success(e) {
      this.ruleForm.bikeTypeImageName = e.name;
      this.ruleForm.bikeTypeImagePath = e.url;
      this.fileList = e.fileList;
    },
  },
};
</script>

<style scoped>
.module-info {
  width: 80%;
}
.company {
  font-size: 14px;
  margin: 0 12px;
}
</style>